import { useSites } from '../../../context/SiteContext';
import { useReportVisits } from '../../../hooks/useReportVisits';
import { buildKeywords } from '../../../lib/analytics';
import { formatNumber } from '../../../lib/format';
import EmptyState from '../../../components/dashboard/EmptyState';
import PageHeader from '../../../components/dashboard/PageHeader';
import StatTable from '../../../components/dashboard/StatTable';
import ExportButton from '../../../components/dashboard/ExportButton';

export default function KeywordsPage() {
  const { currentSite } = useSites();
  const { ranged, range } = useReportVisits(currentSite);
  const keywords = buildKeywords(ranged);
  const total = keywords.reduce((sum, k) => sum + k.pv, 0);

  if (!currentSite) {
    return <EmptyState title="先添加一个站点" desc="添加站点后可监测搜索引擎带来的搜索词。" />;
  }

  return (
    <div>
      <PageHeader
        title="搜索词"
        desc="从百度、360、搜狗等来源里提取访客实际搜索的关键词。"
        range={range}
        extra={
          <ExportButton
            filename={`${currentSite.domain}-keywords.csv`}
            columns={['搜索词', '搜索引擎', '浏览量', '访客', '占比']}
            rows={keywords.map((k) => [
              k.keyword,
              k.engine,
              formatNumber(k.pv),
              formatNumber(k.uv),
              total ? `${((k.pv / total) * 100).toFixed(1)}%` : '0%',
            ])}
          />
        }
      />

      <div className="mt-6 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
        <StatTable
          columns={['搜索词', '搜索引擎', '浏览量', '访客', '占比']}
          rows={keywords.map((k) => [
            k.keyword,
            k.engine,
            formatNumber(k.pv),
            formatNumber(k.uv),
            total ? `${((k.pv / total) * 100).toFixed(1)}%` : '0%',
          ])}
          empty="当前时段暂无搜索词。来路或落地页带有 wd/q/utm_term 时会自动识别；多数搜索引擎 HTTPS 不再带关键词。"
        />
      </div>
    </div>
  );
}
